import { render, staticRenderFns } from "./index.vue?vue&type=template&id=139b5a60&"
import script from "./ReactionsCharts.js?vue&type=script&lang=js&"
export * from "./ReactionsCharts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports